const getApplicationSettings = (state, feature) => state.application[feature]

export const getDestinationsSettings = state =>
  getApplicationSettings(state, 'workspaceDestinations')
